import React, { Component } from 'react';
import PropTypes from 'prop-types';
import staticPath from 'util/misc/static-assets-path';
import { Trans } from 'translations';

export default class ActionTeaser extends Component {
    static propTypes = {
        imagePath: PropTypes.string.isRequired,
        titleTranslationKey: PropTypes.string.isRequired,
        descriptionTranslationKey: PropTypes.string.isRequired,
        children: PropTypes.any,
    };

    render() {
        const { imagePath, titleTranslationKey, descriptionTranslationKey, children } = this.props;
        const image = staticPath(imagePath);

        return (
            <div className="action-teaser grid">
                <div className="action-teaser--row grid--row">
                    <div className="action-teaser--image-col grid--col">
                        <img className="action-teaser--image" src={ image }/>
                    </div>

                    <div className="action-teaser--content-col grid--col">
                        <div className="action-teaser--content-wrapper">
                            <h2 className="u-reset action-teaser--title">
                                <Trans path={ titleTranslationKey }/>
                            </h2>

                            <p className="action-teaser--description">
                                <Trans path={ descriptionTranslationKey }/>
                            </p>

                            <div className="action-teaser--btn-wrapper ">
                                <div className="action-teaser--btn">
                                    { children }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/action-teaser/index.js